// extracted by mini-css-extract-plugin
module.exports = {"documentWrapper":"_6XyMK","titleSection":"_3-TRk","documentList":"_26qbb","btn":"_33OcF"};